var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-wrapper',{attrs:{"title":_vm.title,"message":_vm.message}},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('b-button',{on:{"click":function($event){return _vm.ok()}}},[_vm._v("Ok")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }